import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"; // Add this import

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBgyZ7fFUL4YObOhXGK7LYySj_6lTRuqRY",
  authDomain: "arcamerica-44f6e.firebaseapp.com",
  projectId: "arcamerica-44f6e",
  storageBucket: "arcamerica-44f6e.firebasestorage.app",
  messagingSenderId: "20329530752",
  appId: "1:20329530752:web:53be753f22bf954d8e6d65",
  measurementId: "G-DM8BK0LW4K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app); // Initialize authentication

export { app, analytics, auth }; // Export auth for use in other files